import { LocalizedText, FormAutocompleteField } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropdownItem } from '@optimus-web/core';
import { EmailWhitelistUserData } from '@mews-commander/data-access';
import { WhitelistedEmailConfigurationField } from '../schema';

interface EmailSelectFieldProps {
    availableUsers: EmailWhitelistUserData[];
    disabled: boolean;
}

export const EmailSelectField = ({ availableUsers, disabled }: EmailSelectFieldProps) => (
    <FormAutocompleteField
        required
        label={<LocalizedText textKey={TextKey.Email} />}
        name={WhitelistedEmailConfigurationField.Email}
        disabled={disabled}
    >
        {availableUsers.map(({ id, email }) => (
            <DropdownItem key={id} value={email} label={email} />
        ))}
    </FormAutocompleteField>
);
